import type { Response } from '@swf/core/types/Account';

import { RealMoneyStatus } from '../types/status';

export const deRmfHandleResponse = (response: Response) => {
  const { regAction } = response;
  let globalError;
  /* eslint-disable no-bitwise */
  if (regAction && regAction & (1 << 8)) {
    globalError = RealMoneyStatus.DE_BANNED_BY_REGULATOR;
  } else if (regAction && regAction & (1 << 9)) {
    globalError = RealMoneyStatus.DE_UNBANNED_BY_REGULATOR;
  }

  return (
    globalError &&
    Promise.reject({
      body: {
        globalErrors: [globalError],
        fieldErrors: []
      }
    })
  );
};
